<template>
  <div
    class="management-page"
    :class="{ hideSidebar: isCollapse, openSidebar: !isCollapse }"
  >
    <div class="main-container">
      <sidebar class="sidebar-container" :isCollapse="isCollapse" />
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "@/components/Layout";

export default {
  name: "Layout",
  data() {
    return {
      isCollapse: false,
    };
  },
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  methods: {
    toggleSideBar(flag) {
      this.isCollapse = flag;
    },
  },
};
</script>

